export const AUTH_REQUEST     = 'AUTH_REQUEST'
export const AUTH_SUCCESS     = 'AUTH_SUCCESS'
export const AUTH_ERROR       = 'AUTH_ERROR'
export const AUTH_LOGOUT      = 'AUTH_LOGOUT'
export const SET_CUSTOMER     = 'SET_CUSTOMER'
export const AUTH_RESET_PSWD  = 'AUTH_RESET_PSWD'
export const AUTH_CHANGE_PSWD = 'AUTH_CHANGE_PSWD'
export const AUTH_CHECK_TOKEN = 'AUTH_CHECK_TOKEN'